import type { ColumnFilter } from '../../components/common/FilterableTable/types';

export interface SortOptions {
  column: string;
  direction: 'ascending' | 'descending';
}

export function buildPaginatedQueryParams(
  page: number,
  pageSize: number,
  filters?: ColumnFilter[],
  sort?: SortOptions,
): URLSearchParams {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('page_size', String(pageSize));

  if (filters?.length) {
    params.set('filters', JSON.stringify(filters));
  }

  if (sort) {
    params.set('sort', JSON.stringify(sort));
  }

  return params;
}
